import React, { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';

/* iOS / Android "add to home screen" hint — shown only when not yet
   installed as a PWA. Detects iOS Safari (no beforeinstallprompt) and
   displays manual instructions; on Android Chrome it captures the
   beforeinstallprompt event and triggers it on demand. */
export function AddToHomeHint({ brand }) {
  const tc = brand.text_color || '#FFFFFF';
  const ts = brand.text_secondary_color || '#888888';
  const pc = brand.primary_color || '#D44E20';
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('lazo_a2hs_dismissed') === '1'; } catch { return false; }
  });
  const [iosOpen, setIosOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // Already installed as standalone? Hide.
  const isStandalone = typeof window !== 'undefined' && (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator?.standalone === true
  );
  if (isStandalone || dismissed) return null;

  const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const dismiss = () => {
    try { localStorage.setItem('lazo_a2hs_dismissed', '1'); } catch {}
    setDismissed(true);
  };

  const handleInstall = async () => {
    if (deferred) {
      deferred.prompt();
      const choice = await deferred.userChoice;
      if (choice.outcome === 'accepted') dismiss();
      setDeferred(null);
    } else if (isIOS) {
      setIosOpen(true);
    }
  };

  if (!deferred && !isIOS) return null;

  return (
    <div className="mt-5 rounded-xl border p-3 flex items-start gap-3 animate-fade-in-up" style={{ backgroundColor: `${tc}06`, borderColor: `${pc}30` }} data-testid="a2hs-hint">
      <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${pc}20` }}>
        <Smartphone size={18} style={{ color: pc }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold" style={{ color: tc }}>Aggiungi alla home</p>
        <p className="text-[11px] mt-0.5" style={{ color: ts }}>
          Installa la tua bacheca come app sul telefono per accedere con un tocco.
        </p>
        {iosOpen && (
          <p className="text-[11px] mt-2" style={{ color: ts }} data-testid="a2hs-ios-instructions">
            Tocca <strong style={{ color: tc }}>Condividi</strong> in basso e poi <strong style={{ color: tc }}>Aggiungi a Home</strong>.
          </p>
        )}
        <div className="flex items-center gap-2 mt-2">
          <button onClick={handleInstall} data-testid="a2hs-install-btn"
            className="px-3 py-1.5 rounded-lg text-[11px] font-bold text-white" style={{ backgroundColor: pc }}>
            {isIOS ? 'Mostra come' : 'Installa'}
          </button>
          <button onClick={dismiss} data-testid="a2hs-dismiss-btn" className="text-[11px]" style={{ color: ts }}>
            Non ora
          </button>
        </div>
      </div>
    </div>
  );
}
